export default {
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
} as const
